import {
    SearchSuggestionRendering
} from 'PyzShopUi/scripts/search-suggestion/includes/rendering/SearchSuggestionRendering';

export default class SearchSuggestionHandler {
    public static init = (): void => {
        const searchFormElement: HTMLFormElement = document.querySelector('#article-search');
        const searchSuggestionElement: HTMLElement = document.querySelector('#search-suggestion');

        if (!searchSuggestionElement || !searchFormElement) {
            return;
        }

        new SearchSuggestionRendering(searchSuggestionElement, searchFormElement);
    }
}
